import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Paper } from '@mui/material';
import AdminShell from '../AdminShell';
import UsersView from './UsersView';
import SupportTicketsView from './SupportTicketsView';
import CouponManagement from './CouponManagement';
import BulkEmailView from './BulkEmailView';
import InstallersView from './InstallersView';
import AdminLicenseManagementView from './AdminLicenseManagementView';
import AdminOrgLicensingView from './AdminOrgLicensingView';

const VIEWS = {
  users: UsersView,
  supportTickets: SupportTicketsView,
  coupons: CouponManagement,
  mailUsers: BulkEmailView,
  updateInstaller: InstallersView,
  licenses: AdminLicenseManagementView,
  orgLicensing: AdminOrgLicensingView,
};

const AdminDashboard = () => {
  const location = useLocation();
  // "Back to admin" from an org licensing dashboard (or a user page) returns to the tab it came from.
  const [selectedView, setSelectedView] = useState(location.state?.view || 'users');
  const View = VIEWS[selectedView] || UsersView;

  return (
    <AdminShell selected={selectedView} onSelect={setSelectedView}>
      <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 } }}>
        <View />
      </Paper>
    </AdminShell>
  );
};

export default AdminDashboard;
